import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import {
  Typography,
  IconButton,
  Grid,
  List,
  ListItem,
} from '@material-ui/core';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedinIcon from '@material-ui/icons/LinkedIn';
import { YouTube } from '@material-ui/icons';

import { Image } from 'components/atoms';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(6, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(12, 0),
    },
    background: theme.palette.background.footer,
  },
  footerContainer: {
    maxWidth: theme.layout.contentWidth,
    width: '100%',
    margin: '0 auto',
    padding: theme.spacing(0, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 8),
    },
  },
  logoContainerItem: {
    paddingTop: 0,
  },
  logoContainer: {
    width: 120,
    height: 100,
    [theme.breakpoints.up('md')]: {
      width: 120,
      height: 110,
    },
  },
  logoImage: {
    width: '100%',
    height: '100%',
  },
  groupTitle: {
    textTransform: 'uppercase',
    color: theme.palette.primary.dark,
    marginBottom: theme.spacing(4),
  },
  socialIcon: {
    padding: 2,
    marginRight: theme.spacing(1),
    color: 'rgba(255,255,255,.6)',
    '&:hover': {
      background: 'transparent',
    },
    '&:last-child': {
      marginRight: 0,
    },
  },
  icon: {
    fontSize: 24,
  },
  menuListContainer: {
    padding: '10 !important',
  },
  menu: {
    display: 'flex',
  },
  menuItem: {
    margin: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  menuGroupItem: {
    paddingTop: 0,
    paddingBottom: theme.spacing(1 / 4),
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  menuGroupTitle: {
    textTransform: 'uppercase',
    color: 'white',
  },
  divider: {
    width: '100%',
  },
  navLink: {
    color: 'rgba(255,255,255,.6)',
  },
}));

const Footer = props => {
  const { themeMode , pages, className, ...rest } = props;

  const classes = useStyles();

  const landings = pages.landings;
  const supportedPages = pages.pages;
  // const account = pages.account;

  const MenuGroup = props => {
    const { item } = props;
    return (
      <List disablePadding className={classes.menuItem}>
        <ListItem disableGutters className={classes.menuGroupItem}>
          <Typography variant="body2" className={classes.menuGroupTitle}>
            {item.groupTitle}
          </Typography>
        </ListItem>
        {item.pages.map((page, i) => (
          <ListItem disableGutters key={i} className={classes.menuGroupItem}>
            <Typography
              variant="body2"
              component={'a'}
              href={page.href}
              className={clsx(classes.navLink, 'submenu-item')}
            >
              {page.title}
            </Typography>
          </ListItem>
        ))}
      </List>
    );
  };

  const LandingPages = () => {
    const { services } = landings.children;
    return (
      <div className={classes.menu}>
        <div>
          <MenuGroup item={services} />
          
  
        </div>
        <div>
     
        </div>
      </div>
    );
  };

  const SupportedPages = () => {
    const {
      career,
      // helpCenter,
      company,
      contact,
      blog,
      // portfolio,
    } = supportedPages.children;
    return (
      <div className={classes.menu}>
        <div>
          <MenuGroup item={career} />
          {/* <MenuGroup item={helpCenter} /> */}
        </div>
        <div>
          <MenuGroup item={company} />
          <MenuGroup item={contact} />
        </div>
        <div>
          <MenuGroup item={blog} />
          {/* <MenuGroup item={portfolio} /> */}
        </div>
      </div>
    );
  };

  // const AccountPages = () => {
  //   const { settings,  } = account.children;
  //   return (
  //     <div className={classes.menu}>
  //       <div>
  //         <MenuGroup item={settings}  />
  //         {/* <MenuGroup item={signup} /> */}
  //       </div>
  //       <div>
  //         {/* <MenuGroup item={signin} /> */}
  //         {/* <MenuGroup item={password} /> */}
  //         {/* <MenuGroup item={error} /> */}
  //       </div>
  //     </div>
  //   );
  // };

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div className={classes.footerContainer}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={2}>
            <List disablePadding>
              <ListItem disableGutters className={classes.logoContainerItem}>
                <div className={classes.logoContainer}>
                  <a href="/" title="premas">
                    <Image
                      className={classes.logoImage}
                      src={themeMode === 'dark' ?   'https://onwhicar.sirv.com/premas/main/Premas%20Life%20Sciences%20Logo%20darl.png' : 'https://onwhicar.sirv.com/premas/main/Premas%20Life%20Sciences%20Logo.png'}
           
                    alt="premas"
                      lazy={false}
                    />
                  </a>
                </div>
              </ListItem>
              <ListItem disableGutters>
              <a target="_blank"  rel="noreferrer" href = "https://www.linkedin.com/company/premas-lifesciences/" >
              <IconButton className={classes.socialIcon}>
                <LinkedinIcon 
                className={classes.icon}/>
                
              </IconButton>

              </a>

              <a target="_blank"  rel="noreferrer" href = "https://www.facebook.com/connectpls/" >
              <IconButton className={classes.socialIcon}>
                <FacebookIcon className={classes.icon} />
              </IconButton>
              </a>
  
              <a target="_blank"  rel="noreferrer" href = "https://twitter.com/PremasLifeSc" >
              <IconButton className={classes.socialIcon}>
                <TwitterIcon className={classes.icon} />
              </IconButton>
              </a>

              < a href = "https://www.youtube.com/channel/UCBI_XOgvOOUIlFW9pZzYWYg">
              <IconButton target="_blank"className={classes.socialIcon} >
                <YouTube className={classes.icon} />
              </IconButton>
              </a>
              </ListItem>
            </List>
          </Grid>
          <Grid item xs={12} md={10} className={classes.menuListContainer}>
            <Grid container spacing={0}>
              <Grid item>
                <LandingPages />
              </Grid>
              <Grid item>
                <SupportedPages />
              </Grid>
              <Grid item>
                {/* <AccountPages /> */}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <br/>
      <br/>
      <br/>
      <h3 align = 'center'>copyright @ 2022 - Premas Life Sciences</h3>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.object.isRequired,
};

export default Footer;
